import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';

@Component({
  selector: 'app-formly-checkbox',
  templateUrl: './formly-checkbox.component.html',
  styleUrl: './formly-checkbox.component.scss',
  imports: [FormsModule, ReactiveFormsModule, FormlyModule],
})
export class FormlyCheckboxComponent extends FormlyFieldBaseComponent {
  change(event: any) {
    if (this.props.onChange) {
      this.props.onChange(event.target.value);
    }
  }
}
